import React, { JSX } from 'react';
import Styles from './FalconButtonV2.module.scss';
import { getSBAssetUrl } from '../../utils/utils';
import { Spinner } from 'react-bootstrap';

const FaIcon = ({
  path,
  style,
  className
}: {
  path: string;
  className?: string;
  style?: Record<string, string>;
}) => {
  return (
    <span
      className={`${Styles.icon} ${className}`}
      style={{
        maskImage: `url(${path})`,
        WebkitMaskImage: `url(${path})`,
        ...style
      }}
    ></span>
  );
};

const FalconButtonV2 = ({
  content,
  className,
  icon,
  iconClass,
  isLoading,
  wafIdentifier,
  ...restProps
}: any): JSX.Element => {
  let btn;
  // btn icon
  let image = content?.buttonIcon?.filename && (
    <FaIcon
      path={getSBAssetUrl(wafIdentifier, content?.buttonIcon?.filename)}
      className={iconClass}
    />
  );
  if (!image && icon) {
    image = <FaIcon path={icon} style={{ height: '24px', width: '24px' }} />;
  }
  // additional classNames on btn
  const classNames = `${Styles.button} ${Styles[content?.buttonType]} btn ${className} }`;
  // accumulating all props
  const allProps = { ...restProps, className: classNames };
  //icons position wrt text
  const innerContent =
    content?.buttonAlignment === 'left' ? (
      <span className='d-flex gap-2 justify-content-center'>
        {image}
        {content?.buttonLabel}
      </span>
    ) : (
      <span className='d-flex gap-2 justify-content-center'>
        {content?.buttonLabel}
        {image}
      </span>
    );

  if (content?.buttonLink?.url)
    btn = (
      <a href={content?.buttonLink?.url} {...allProps}>
        {innerContent}
      </a>
    );
  else
    btn = (
      <button {...allProps}>
        {isLoading ? <Spinner animation='border' size='sm' /> : innerContent}
      </button>
    );

  return btn;
};

export default FalconButtonV2;
